import type { FC, PropsWithChildren } from 'react'
import { Box, Link, useColorMode, Text } from '@chakra-ui/react'
import { useRecoilValue } from 'recoil'
import { circlesBreakpointState } from '../../state'
import { getBreakpointValue } from '../../utils'

export const SimplePageWrap: FC<PropsWithChildren> = ({ children }) => {
	const { colorMode } = useColorMode()
	const circlesBreakpoint = useRecoilValue(circlesBreakpointState)
	const w = getBreakpointValue({ base: '26px', lg: '30px' }, circlesBreakpoint)
	const bgImage = colorMode === 'light'
		? 'url(/TimechainCalendarIconLight.png)'
		: 'url(/icon-tc-512.png)'

	return (
		<Box
			w="100vw"
			minH="100vh"
			bg="black"
			color="white"
			overflow="auto"
			position="relative"
		>
			{/* Logo - Top Left */}
			<Box
				position="absolute"
				top={2}
				left={2}
				zIndex={100}
			>
				<Link href="/">
					<Box 
						h={w}
						w={w}
						backgroundImage={bgImage}
						backgroundPosition="center center"
						backgroundSize="contain"
						backgroundRepeat="no-repeat"
						boxShadow="none"
					/>
				</Link>
			</Box>

			{/* Content */}
			{children}

			{/* Version - Bottom Right */}
			<Box
				position="absolute"
				bottom={4}
				right={4}
				zIndex={100}
			>
				<Text
					fontSize="12px"
					color="gray.500"
					opacity={0.7}
				>
					v{process.env.REACT_APP_VERSION}
				</Text>
			</Box>
		</Box>
	)
}